import { render } from "./HeaderPagesButton.vue?vue&type=template&id=4dd53b1a&scoped=true"
import script from "./HeaderPagesButton.vue?vue&type=script&lang=js"
export * from "./HeaderPagesButton.vue?vue&type=script&lang=js"

import "./HeaderPagesButton.vue?vue&type=style&index=0&id=4dd53b1a&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd53b1a"]])

export default __exports__